import { MyPracticeDetailsContext } from 'components_v2/page_context'
import React from 'react'

export const MyPracticeDetailsProvider = (props) => {
  return (
    <MyPracticeDetailsContext.Provider
      value={{
        completedContext: [props.selectedOptions, props.setSelectedOptions],
        classesContext: [
          props.selectedClassesOptions,
          props.setSelectedClassesOptions
        ],
        daysContext: [props.days, props.setDays]
      }}
    >
      {props.children}
    </MyPracticeDetailsContext.Provider>
  )
}
